'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Configuration = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // like lodash.get, but supports an additional optional query
// get(object, 'foo.bar', 'foo.baz', false);


var get = function get(obj, a, b, c) {
  return (0, _lodash2.default)(obj, a, typeof b === 'string' ? (0, _lodash2.default)(obj, b, c) : b);
};

var Configuration = exports.Configuration = function () {
  function Configuration(data) {
    _classCallCheck(this, Configuration);

    this._data = data;
  }

  _createClass(Configuration, [{
    key: 'isBugsnagEnabled',
    value: function isBugsnagEnabled() {
      return get(this._data, 'bugsnag.enabled', 'configuration.bugsnag.enabled', false);
    }
  }, {
    key: 'isGoogleAnalyticsEnabled',
    value: function isGoogleAnalyticsEnabled() {
      return true;
    }
  }, {
    key: 'isHeapAnalyticsEnabled',
    value: function isHeapAnalyticsEnabled() {
      return true;
    }
  }, {
    key: 'isLaunchDarklyEnabled',
    value: function isLaunchDarklyEnabled() {
      return true;
    }
  }, {
    key: 'isQualarooEnabled',
    value: function isQualarooEnabled() {
      return get(this._data, 'qualaroo.enabled', 'configuration.qualaroo.enabled', false);
    }
  }, {
    key: 'isFullstoryEnabled',
    value: function isFullstoryEnabled() {
      return get(this._data, 'fullstory.enabled', 'configuration.fullStory.enabled', false);
    }
  }, {
    key: 'isWalkMeEnabled',
    value: function isWalkMeEnabled() {
      return get(this._data, 'walkme.enabled', 'configuration.walkMe.enabled', false);
    }
  }, {
    key: 'isZendeskChatEnabled',
    value: function isZendeskChatEnabled() {
      return get(this._data, 'zendesk_chat.enabled', 'configuration.zendeskChat.enabled', false);
    }
  }, {
    key: 'isZendeskChatHidden',
    value: function isZendeskChatHidden() {
      return get(this._data, 'zendesk_chat.hide', 'configuration.zendeskChat.hide', false);
    }
  }, {
    key: 'getBugsnagApiKey',
    value: function getBugsnagApiKey() {
      return get(this._data, 'bugsnag.api_key', 'configuration.bugsnag.apiKey');
    }
  }, {
    key: 'getWalkMeApiKey',
    value: function getWalkMeApiKey() {
      return get(this._data, 'walkme.api_key', 'configuration.walkMe.apiKey');
    }
  }, {
    key: 'getQualarooClientId',
    value: function getQualarooClientId() {
      return get(this._data, 'qualaroo.client_id', 'configuration.qualaroo.clientId');
    }
  }, {
    key: 'getGoogleAnalyticsTrackingId',
    value: function getGoogleAnalyticsTrackingId() {
      return get(this._data, 'google_analytics.tracking_id', 'configuration.googleAnalytics.trackingId');
    }
  }, {
    key: 'getHeapAnalyticsApiKey',
    value: function getHeapAnalyticsApiKey() {
      return get(this._data, 'heap_analytics.key', 'configuration.heapAnalytics.key');
    }
  }, {
    key: 'getFullstoryConfig',
    value: function getFullstoryConfig() {
      return get(this._data, 'fullstory', 'configuration.fullStory');
    }
  }, {
    key: 'getUserId',
    value: function getUserId() {
      return get(this._data, 'user_id', 'me.id');
    }
  }, {
    key: 'getFullName',
    value: function getFullName() {
      return get(this._data, 'me.fullName');
    }
  }, {
    key: 'getEmail',
    value: function getEmail() {
      return get(this._data, 'me.email');
    }
  }, {
    key: 'getUserCreatedDate',
    value: function getUserCreatedDate() {
      return get(this._data, 'user_created_date', 'me.createdAt');
    }
  }, {
    key: 'getEnvironment',
    value: function getEnvironment() {
      return get(this._data, 'environment', 'configuration.environment');
    }
  }, {
    key: 'getFeatureFlagData',
    value: function getFeatureFlagData() {
      if (this._data.feature_flag_data) {
        return this._data.feature_flag_data;
      } else {
        return {
          client_id: this._data.configuration.launchDarkly.clientId,
          flags: this._data.configuration.launchDarkly.flags,
          user: {
            key: this._data.me.email,
            email: this._data.me.email,
            name: this._data.me.fullName,
            custom: {
              user_id: Number(this._data.me.id),
              client: this._data.me.client.name,
              roles: this._data.me.roles.map(function (role) {
                return role.name.toLowerCase();
              })
            }
          }
        };
      }
    }
  }, {
    key: 'getClientID',
    value: function getClientID() {
      return get(this._data, 'client_id', 'me.client.id');
    }
  }]);

  return Configuration;
}();